import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FakeDbService } from '@fake-db/fake-db.service';

import 'hammerjs';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { ContextMenuModule } from '@ctrl/ngx-rightclick';

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';

import { coreConfig } from 'app/app-config';
import { AuthGuard } from 'app/auth/helpers/auth.guards';
import { fakeBackendProvider } from 'app/auth/helpers'; // used to create fake backend
import { JwtInterceptor, ErrorInterceptor } from 'app/auth/helpers';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';

import { NgbCustomDateParserFormatter } from './main/_util/ngb-custom-date-parser-formatter';
import { PCalendarLocalDirective } from './main/_util/pcalendar-local.directive';
import {TableModule} from 'primeng/table';
const config: ExtraOptions = {
  useHash: true,
};
const appRoutes: Routes = [
  {
    path: 'usuario',
    loadChildren: () => import('./main/pages/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'ahorros',
    loadChildren: () => import('./main/pages/ahorros/ahorros.module').then(m => m.AhorrosModule)
  },
  {
    path: 'creditos',
    loadChildren: () => import('./main/pages/creditos/creditos.module').then(m => m.CreditosModule)
  },
  {
    path: 'inversiones',
    loadChildren: () => import('./main/pages/inversiones/inversiones.module').then(m => m.InversionesModule)
  },
  {
    path: 'descuentos',
    loadChildren: () => import('./main/pages/descuentos/descuentos.module').then(m => m.DescuentosModule)
  },
  {
    path: 'garantias',
    loadChildren: () => import('./main/pages/garantias/garantias.module').then(m => m.GarantiasModule)
  },
  {
    path: 'transferencias',
    loadChildren: () => import('./main/pages/transferencias/transferencias.module').then(m => m.TransferenciasModule)
  },
  {
    path: 'certificados',
    loadChildren: () => import('./main/pages/certificados/certificados.module').then(m => m.CertificadosModule)
  },
  {
    path: 'autorizaciones',
    loadChildren: () => import('./main/pages/autorizaciones/autorizaciones.module').then(m => m.AutorizacionesModule)
  },
  {
    path: '',
    loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'inicio',
    redirectTo: '/ahorros/productos',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/seguridad/error' //Error 404 - Page not found
  }
];

@NgModule({
  declarations: [
    AppComponent,
    PCalendarLocalDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientInMemoryWebApiModule.forRoot(FakeDbService, {
      delay: 0,
      passThruUnknownUrl: true
    }),
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', // Add options right here
      relativeLinkResolution: 'legacy',
      useHash: false //usar tru para colocar /#/
    }),
    NgbModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot(),
    ContextMenuModule,
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    CardSnippetModule,
    LayoutModule,
    ContentHeaderModule,
    TableModule
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend, comment while using real api
    fakeBackendProvider,
    {
      provide: NgbDateParserFormatter,
      useValue: new NgbCustomDateParserFormatter("YYYY-MM-DD") // <== format!
    }
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
